var _path, _path2, _path3, _path4, _path5, _path6, _rect, _g, _path7, _path8, _rect2, _g2, _rect3, _g3, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPear(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 280,
    height: 280,
    viewBox: "0 0 280 280",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M140 275C65.4 275 5 214.6 5 140C5 65.4 65.4 5 140 5C214.6 5 275 65.4 275 140C275 214.6 214.6 275 140 275Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M171.6 31.5C171.6 32.8 171.1 34 170.3 34.9C169.3 35.4 168.3 35.9 167.3 36.5C159.1 41.4 153.6 50.3 153.6 60.5C153.6 60.6 153.6 60.7 153.6 60.8C152.7 60.6 151.7 60.5 150.6 60.5C149.2 60.5 147.8 60.7 146.6 61C145.9 58.6 145.6 56.1 145.6 53.5C145.6 41.3 153.3 31 164.2 27.1C164.8 26.9 165.5 26.7 166.1 26.5C166.3 26.5 166.4 26.5 166.6 26.5C169.4 26.5 171.6 28.8 171.6 31.5Z",
    fill: "#6E3126"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M154.237 49.007C157.876 47.4053 159.997 44.2218 158.974 41.8964C157.951 39.5711 154.171 38.9845 150.531 40.5862C146.891 42.1879 144.77 45.3714 145.794 47.6968C146.817 50.0221 150.597 50.6087 154.237 49.007Z",
    fill: "#6E3126"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M78.2999 136.5C78.2999 136.5 58.5999 166.8 67.0999 188.7",
    stroke: "#3A3A3A",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M120.623 190.237L112.65 190.898L115.788 228.768L123.761 228.108L120.623 190.237Z",
    fill: "#1F201D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M165.2 190.5H157.2V228.5H165.2V190.5Z",
    fill: "#1F201D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_375",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 97,
    y: 241,
    width: 90,
    height: 15
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 97,
    y: 241,
    width: 90,
    height: 15,
    fill: "url(#pattern0)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_375)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M141.7 253.5C165.172 253.5 184.2 251.261 184.2 248.5C184.2 245.739 165.172 243.5 141.7 243.5C118.228 243.5 99.2 245.739 99.2 248.5C99.2 251.261 118.228 253.5 141.7 253.5Z",
    fill: "#BFC3CE"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M111.7 246.5C121.365 246.5 129.2 241.575 129.2 235.5C129.2 229.425 121.365 224.5 111.7 224.5C102.035 224.5 94.2 229.425 94.2 235.5C94.2 241.575 102.035 246.5 111.7 246.5Z",
    fill: "#1F201D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M169.7 246.5C179.365 246.5 187.2 241.575 187.2 235.5C187.2 229.425 179.365 224.5 169.7 224.5C160.035 224.5 152.2 229.425 152.2 235.5C152.2 241.575 160.035 246.5 169.7 246.5Z",
    fill: "#1F201D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1_375",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 97,
    y: 228,
    width: 10,
    height: 10
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 97,
    y: 228,
    width: 10,
    height: 10,
    fill: "url(#pattern1)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1_375)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.7 235.5C103.081 235.5 104.2 234.381 104.2 233C104.2 231.619 103.081 230.5 101.7 230.5C100.319 230.5 99.2 231.619 99.2 233C99.2 234.381 100.319 235.5 101.7 235.5Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1_375",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 176,
    y: 228,
    width: 10,
    height: 10
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 228,
    width: 10,
    height: 10,
    fill: "url(#pattern2)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1_375)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M180.7 235.5C182.081 235.5 183.2 234.381 183.2 233C183.2 231.619 182.081 230.5 180.7 230.5C179.319 230.5 178.2 231.619 178.2 233C178.2 234.381 179.319 235.5 180.7 235.5Z",
    fill: "white"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M196.2 107.2C199.8 110.5 203.1 114.2 205.6 118.5C211 127.7 214 138.3 214 149.4C214 186 181.3 215.7 141 215.7C100.7 215.7 68 186 68 149.4C68 130.3 76.9 113.1 91.1 101.1C91.8 100.5 92.5 100 93.3 99.7C95.9 98.6 98.2 96.8 99.9 94.7C101.3 92.9 102.4 90.9 103.1 88.6C103.6 87 103.8 85.4 103.8 83.7C103.8 83.4 103.8 83.2 103.8 82.9C103.7 81.4 103.9 79.8 104.2 78.4C108.7 58.6 126.4 43.9 147.6 43.9C172.2 43.9 192.1 63.8 192.1 88.4V88.5C190.9 90.7 190.9 94.8 190.9 94.8C190.9 95.8 191 96.7 191.1 97.6C191.4 99.5 192 101.3 192.9 102.9C193.4 103.8 193.9 104.6 194.5 105.4C194.4 105.3 194.9 106 196.2 107.2Z",
    fill: "#FDCD04"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M215 149.4C215 186 182.3 215.7 142 215.7H141.9C140.2 215.7 139.9 213.3 141.5 212.8C171.5 204.5 193.3 179.3 193.3 149.4C193.3 138.2 190.3 127.7 184.9 118.5C182.4 114.3 179.2 110.5 175.5 107.2C174.2 106 173.7 105.3 173.7 105.3C173.1 104.5 172.6 103.7 172.1 102.8C171.3 101.2 170.7 99.4 170.3 97.5C170.2 96.6 170.1 95.7 170.1 94.7C170.1 94.6 170.1 91.7 170.8 89.6C171.1 88.6 171.2 87.6 171.2 86.5C171.2 69.3 161.5 56.2 147.2 48.8C144.8 47.6 145.7 43.9 148.4 43.9H148.5C171.9 43.9 191.1 62 192.9 85C193 86.8 192.8 88.5 192.3 90.2C191.7 92.3 191.8 94.6 191.8 94.7C191.8 95.7 191.9 96.6 192 97.5C192.3 99.4 192.9 101.2 193.8 102.8C194.3 103.7 194.8 104.5 195.4 105.3C195.4 105.3 195.9 106 197.2 107.2C200.8 110.5 204.1 114.2 206.6 118.5C212 127.7 215 138.3 215 149.4Z",
    fill: "#C69A12"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M140.5 173.3C141.881 173.3 143 172.181 143 170.8C143 169.419 141.881 168.3 140.5 168.3C139.119 168.3 138 169.419 138 170.8C138 172.181 139.119 173.3 140.5 173.3Z",
    fill: "#C69A12"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M168.9 145.4C170.281 145.4 171.4 144.281 171.4 142.9C171.4 141.519 170.281 140.4 168.9 140.4C167.519 140.4 166.4 141.519 166.4 142.9C166.4 144.281 167.519 145.4 168.9 145.4Z",
    fill: "#C69A12"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M162.5 111.3C163.881 111.3 165 110.181 165 108.8C165 107.419 163.881 106.3 162.5 106.3C161.119 106.3 160 107.419 160 108.8C160 110.181 161.119 111.3 162.5 111.3Z",
    fill: "#C69A12"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M142.2 148.8C143.581 148.8 144.7 147.681 144.7 146.3C144.7 144.919 143.581 143.8 142.2 143.8C140.819 143.8 139.7 144.919 139.7 146.3C139.7 147.681 140.819 148.8 142.2 148.8Z",
    fill: "#C69A12"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M118.5 195.3C119.881 195.3 121 194.181 121 192.8C121 191.419 119.881 190.3 118.5 190.3C117.119 190.3 116 191.419 116 192.8C116 194.181 117.119 195.3 118.5 195.3Z",
    fill: "#C69A12"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M92.2 133.8C93.5807 133.8 94.7 132.681 94.7 131.3C94.7 129.919 93.5807 128.8 92.2 128.8C90.8192 128.8 89.7 129.919 89.7 131.3C89.7 132.681 90.8192 133.8 92.2 133.8Z",
    fill: "#C69A12"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M141.2 68.8C142.581 68.8 143.7 67.6807 143.7 66.3C143.7 64.9193 142.581 63.8 141.2 63.8C139.819 63.8 138.7 64.9193 138.7 66.3C138.7 67.6807 139.819 68.8 141.2 68.8Z",
    fill: "#C69A12"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M131.7 119.5C133.081 119.5 134.2 118.381 134.2 117C134.2 115.619 133.081 114.5 131.7 114.5C130.319 114.5 129.2 115.619 129.2 117C129.2 118.381 130.319 119.5 131.7 119.5Z",
    fill: "#C69A12"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M114.2 99.8C115.581 99.8 116.7 98.6807 116.7 97.3C116.7 95.9193 115.581 94.8 114.2 94.8C112.819 94.8 111.7 95.9193 111.7 97.3C111.7 98.6807 112.819 99.8 114.2 99.8Z",
    fill: "#C69A12"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M145.9 95.4C147.281 95.4 148.4 94.2807 148.4 92.9C148.4 91.5193 147.281 90.4 145.9 90.4C144.519 90.4 143.4 91.5193 143.4 92.9C143.4 94.2807 144.519 95.4 145.9 95.4Z",
    fill: "#C69A12"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M166.2 174.8C167.581 174.8 168.7 173.681 168.7 172.3C168.7 170.919 167.581 169.8 166.2 169.8C164.819 169.8 163.7 170.919 163.7 172.3C163.7 173.681 164.819 174.8 166.2 174.8Z",
    fill: "#C69A12"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5 168.3C97.8807 168.3 99 167.181 99 165.8C99 164.419 97.8807 163.3 96.5 163.3C95.1193 163.3 94 164.419 94 165.8C94 167.181 95.1193 168.3 96.5 168.3Z",
    fill: "#C69A12"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M115.5 174.3C116.881 174.3 118 173.181 118 171.8C118 170.419 116.881 169.3 115.5 169.3C114.119 169.3 113 170.419 113 171.8C113 173.181 114.119 174.3 115.5 174.3Z",
    fill: "#C69A12"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M108.2 125.8C111.79 125.8 114.7 122.89 114.7 119.3C114.7 115.71 111.79 112.8 108.2 112.8C104.61 112.8 101.7 115.71 101.7 119.3C101.7 122.89 104.61 125.8 108.2 125.8Z",
    fill: "#4C1A1D"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M150.2 125.8C153.79 125.8 156.7 122.89 156.7 119.3C156.7 115.71 153.79 112.8 150.2 112.8C146.61 112.8 143.7 115.71 143.7 119.3C143.7 122.89 146.61 125.8 150.2 125.8Z",
    fill: "#4C1A1D"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M141.6 133.7C143.1 139.6 139.6 145.6 133.8 147.1C127.9 148.6 121.9 145.1 120.4 139.3",
    fill: "#FFF3F3"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M141.5 55.1C141.4 57.6 139.3 59.5 136.8 59.4C134.3 59.3 132.4 57.2 132.5 54.7C132.6 52.2 134.7 50.3 137.2 50.4C139.7 50.6 141.6 52.6 141.5 55.1Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M131.2 64.3C131.2 65.8 130.6 67.1 129.7 68.1C129.3 68.4 129 68.6 128.7 68.9C124.4 72.7 121.3 77.9 120.2 83.8C120.1 84.1 120.1 84.4 120 84.7C119.4 87 117.2 88.7 114.7 88.7C111.9 88.7 109.7 86.7 109.3 84.1C109.3 83.7 109.2 83.3 109.2 82.9C109.2 82.7 109.2 82.4 109.2 82.2C109.2 72.6 114.5 64.2 122.5 59.7C122.9 59.5 123.3 59.2 123.8 59C124.4 58.8 125.1 58.6 125.7 58.6C128.8 58.8 131.2 61.3 131.2 64.3Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M202.2 147.1C202.2 147.1 211.2 182.1 196.2 200.1",
    stroke: "#3A3A3A",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1_375",
    transform: "scale(0.0111111 0.0666667)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern1",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image1_1_375",
    transform: "scale(0.1)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern2",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image1_1_375",
    transform: "scale(0.1)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1_375",
    width: 90,
    height: 15,
    xlinkHref: "data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEASABIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMAEAMCAwYAAAGlAAACAwAAAs7/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoXHh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoaJjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIAA8AWgMBIgACEQEDEQH/xACJAAADAQEBAAAAAAAAAAAAAAAABAYFAgMBAQAAAAAAAAAAAAAAAAAAAAAQAAAGAgIDAQAAAAAAAAAAAAABAwQFBgIHFhcQIBESEQABAgMFBgQHAAAAAAAAAAABAAIRAwQhMaHREpGSkxQFNRBBQtOBsTJyE2ODEgEAAAAAAAAAAAAAAAAAAAAg/9oADAMBAAIRAxEAAACMqJamNFxJs9QADgUUaSJ/J1Ms/9oACAECAAEFAPb/2gAIAQMAAQUA9v/aAAgBAQABBQCOiHcjm01q8UMtYIhLW0Rjh1xBjriDHXEGD1xC/M9YNzyd6zc4CSrchHGGCkonk0nb0kZWu5EELdYSw5fMjl8yOXzIVt09+DtdyDqwXpXKTczy/j//2gAIAQICBj8AX//aAAgBAwIGPwBf/9oACAEBAQY/AA2QBCMC5xQdPqA1hHpFuMVbVv2DJATHve4Xu1ER2K9+8c1e/eOavfvHNWF4P3HNEsq3hpNgsswQNNUggX6xE4QTjNDXMb6gbdnhGgE0n9bS75ApsKGomyxeOXm2/GC7JUH+M320OY6FWa/PRImEYtC7DXcB+S7DXcB+S7DXcB+SP4uhVmvy1SHwjuldkqODN9tRb06olMh9PLzTjpCceoMnMab2vluY0bR4f//Z"
  }), /*#__PURE__*/React.createElement("image", {
    id: "image1_1_375",
    width: 10,
    height: 10,
    xlinkHref: "data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEASABIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMAEAMCAwYAAAF3AAABiAAAAbX/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoXHh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoaJjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIAAoACgMBIgACEQEDEQH/xABrAAEBAQAAAAAAAAAAAAAAAAAABQYBAQAAAAAAAAAAAAAAAAAAAAAQAAIDAAAAAAAAAAAAAAAAAAAFEAQGEQAABQUAAAAAAAAAAAAAAAARMRIDBCABAiIyEgEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIRAxEAAACDnQ//2gAIAQIAAQUAP//aAAgBAwABBQA//9oACAEBAAEFAFihNYz8/wD/2gAIAQICBj8Af//aAAgBAwIGPwB//9oACAEBAQY/AJE2Q+mY2pOI8gWtjo//2Q=="
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPear);
export default __webpack_public_path__ + "static/media/pear.e5903f064be6c511699a737c131110ec.svg";
export { ForwardRef as ReactComponent };